// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__OoJ5h","requiredAsterisk":"Info_requiredAsterisk__3lEvE"};